import { Button } from "../ui/button";
import { Input } from "../ui/input";
import DateInput from "../DateInput";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Calendar, Trash2 } from "lucide-react";

export const EditGiornoDialog = ({ open, onOpenChange, data, nuovaData, onNuovaDataChange, entrateDelGiorno, bancaNomeById, onSave, onDelete, formatDateIT }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-sm rounded-3xl bg-card border-border">
      <DialogHeader>
        <DialogTitle className="text-foreground flex items-center gap-2">
          <Calendar className="h-5 w-5 text-lime-400" />
          Modifica Data Riga
        </DialogTitle>
      </DialogHeader>
      
      <div className="space-y-4">
        <div className="space-y-2">
          <Label className="text-foreground/70">Nuova Data</Label>
          <DateInput value={nuovaData} onChange={(v) => onNuovaDataChange(v)} />
        </div>
        
        <div className="bg-card rounded-xl p-3 border border-border">
          <p className="text-muted-foreground text-xs mb-2">Entrate che verranno spostate:</p>
          <div className="space-y-1">
            {entrateDelGiorno.map((entrata) => (
              <div key={entrata.id} className="flex items-start justify-between text-sm">
                <div>
                  <span className="text-foreground/70">{entrata.metodo}</span>
                  {(entrata.split_pos || []).map((split) => (
                    <div key={split.banca_id} className="text-xs text-blue-500" data-testid={`edit-day-pos-bank-${split.banca_id}`}>
                      {bancaNomeById?.get(split.banca_id) || split.banca_nome || "POS"}: € {Number(split.importo).toFixed(2)}
                    </div>
                  ))}
                </div>
                <span className="text-lime-400 font-medium">€ {entrata.importo.toFixed(2)}</span>
              </div>
            ))}
          </div>
          <div className="border-t border-border mt-2 pt-2 flex justify-between">
            <span className="text-muted-foreground text-sm">Totale</span>
            <span className="text-lime-400 font-bold">€ {entrateDelGiorno.reduce((s, e) => s + e.importo, 0).toFixed(2)}</span>
          </div>
        </div>
        
        {nuovaData !== data && (
          <p className="text-amber-400 text-sm text-center">
            Tutte le entrate saranno spostate da {formatDateIT(data, true)} a {formatDateIT(nuovaData, true)}
          </p>
        )}
      </div>
      
      <DialogFooter className="flex-col gap-2 pt-4">
        <div className="flex gap-2 w-full">
          <Button 
            type="button" 
            variant="outline" 
            onClick={() => onOpenChange(false)} 
            className="flex-1 border-border text-foreground hover:bg-accent hover:text-accent-foreground"
          >
            Annulla
          </Button>
          <Button 
            onClick={onSave}
            className="flex-1 bg-primary hover:bg-primary/90 text-white font-bold"
          >
            Salva
          </Button>
        </div>
        <Button 
          variant="ghost"
          onClick={onDelete}
          className="w-full text-red-400 hover:text-red-300 hover:bg-red-500/10"
        >
          <Trash2 className="h-4 w-4 mr-2" />
          Elimina tutta la riga
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
